export default "__VITE_ASSET__4a295f10__"